import { render, staticRenderFns } from "./modes.vue?vue&type=template&id=0e80253f&"
import script from "./modes.vue?vue&type=script&lang=js&"
export * from "./modes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports